export default __webpack_public_path__ + "static/media/instrucciones-3.2b21f8cb.jpg";